import type { Logger } from 'utils/logging.client';
import pino from '../next-logger.config';

const logger = pino.logger({});

// This is the server implementation, the client version is `logging.client.ts`
// which is configured through an alias in `vite.config.mjs`

export const Log: Logger = {
  debug(args) {
    logger.debug(args);
  },
  info(args) {
    logger.info(args);
  },
  warn(args) {
    logger.warn(args);
  },
  error(args) {
    logger.error(args);
  },
};

export default Log;
